<template>
  <div class="basics-element">
    <el-row type="flex" v-show="!isShowDetails" style="height:100%;">
      <div class="side-bar">
        <el-tree
          :data="data1"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :check-strictly="true"
          :check-on-click-node="true"
          :expand-on-click-node="false"
          @node-click="change"
          @check="changes"
          :default-checked-keys="defaultKey"
          :props="defaultProps">
        </el-tree>
      </div>
      <div class="basics-right" style="overflow: auto">
        <Xyj-remote-table ref="reftableBasicsElement" id="1" v-bind="tablemain">
          <template slot="xyjcontainer">
            <Xyj-button v-if="hasOperation" @click="addNew($event)" size="mini" type="primary" :label="$t('action.add')" text="新增"></Xyj-button>
          </template>
          <template slot="otherOperations" slot-scope="scope">
            <Xyj-button size="mini" @click="editRow(scope.list,$event)" type="primary" style="padding: 7px 8px" :label="$t('action.edit')" text="编辑"></Xyj-button>
            <Xyj-button size="mini" @click="openView(scope.list,$event)" type="primary" style="padding: 7px 8px" :label="$t('action.editcode')" text="编辑代码">
            </Xyj-button>
            <Xyj-button v-if="scope.list.enabledState == '0'" type="primary" size="mini" @click="enabled(scope.list,$event)"
                       style="padding: 7px 8px" :label="$t('action.enable')" text="启用">
            </Xyj-button>
            <Xyj-button v-if="scope.list.enabledState == '1'" type="warning" size="mini" @click="enabled(scope.list,$event)"
                       style="padding: 7px 8px" :label="$t('action.disable')" text="停用">
            </Xyj-button>
            <Xyj-button size="mini" @click="deleteRow(scope.list,$event)" type="danger" style="padding: 7px 8px" :label="$t('action.delete')" text="删除"></Xyj-button>
          </template>
        </Xyj-remote-table>
      </div>
    </el-row>


    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :title="isNew?'新增':'编辑'"
      :visible.sync="dialogVisible"
      width="500px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" size="small" class="demo-ruleForm">
        <el-form-item label="组件名称" prop="componentName">
          <el-input v-model="ruleForm.componentName" @input="componentNameInput" placeholder="只能输入小写英文+数字"></el-input>
        </el-form-item>
        <el-form-item label="组件类型" prop="componentType">
          <el-radio-group v-model="ruleForm.componentType" @change="componentTypeChange" >
            <el-radio :label="0">PC组件</el-radio>
            <el-radio :label="1">移动端组件</el-radio>
          </el-radio-group>
        </el-form-item>
<!--        <el-form-item label="组件版本" prop="componentVersion">-->
<!--          <el-input v-model="ruleForm.componentVersion"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="组件路径" prop="elementName">
          <el-input v-model="ruleForm.elementName" @input="elementNameInput" placeholder="只能输入小写英文+数字"></el-input>
        </el-form-item>

        <el-form-item label="组件中文名称" prop="componentChineseName">
          <el-input v-model="ruleForm.componentChineseName"></el-input>
        </el-form-item>

        <el-form-item label="项目名称" prop="projectCode">
          <el-select v-model="ruleForm.projectCode" style="width:100%">
            <el-option v-for="(item,index) in project" :key="index" :label="item.projectName" :value="item.projectCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态" prop="enabledState">
          <el-radio-group v-model="ruleForm.enabledState" >
            <el-radio :label="0">停用</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否缓存" prop="cacheStatus">
          <el-radio-group v-model="ruleForm.cacheStatus" >
            <el-radio :label="0">不缓存</el-radio>
            <el-radio :label="1">缓存</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否首页" prop="homeState">
          <el-radio-group v-model="ruleForm.homeState" :disabled="ruleForm.componentType=='0'">
            <el-radio label="1">首页</el-radio>
            <el-radio label="0">非首页</el-radio>
            <el-radio label="2">登录页</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="登入状态" prop="loginState">
          <el-radio-group v-model="ruleForm.loginState" :disabled="ruleForm.componentType=='0'">
            <el-radio label="1">登入后</el-radio>
            <el-radio label="0">登入前</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否可拖拽" prop="dragStatus" style="text-align:left;">
          <el-switch
            v-model="ruleForm.dragStatus"
            active-value=1
            inactive-value=0>
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="isShowDetails" class="details-page">
      <el-row class="details-header" type="flex" justify="space-between">
        <el-button size="mini" @click="goBack" icon="el-icon-back" type="warning">返回</el-button>
        <b>{{currComponentName}} 代码编辑</b>
        <el-button size="mini" @click="save" icon="el-icon-check" type="success">保存</el-button>
      </el-row>
      <el-row style="flex: 1;overflow: auto;">
        <div class="in-coder-panel" style="">
          <textarea ref="textarea"></textarea>
          <el-select class="code-mode-select" v-model="mode"
                     @change="changeMode">
            <el-option v-for="mode in modes"
                       :key="mode.value" :label="mode.label" :value="mode.value">
            </el-option>
          </el-select>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
  import axios from "@/http/axios";
  // 引入全局实例
  import _CodeMirror from 'codemirror'

  // 核心样式
  import 'codemirror/lib/codemirror.css'
  // 引入主题后还需要在 options 中指定主题才会生效
  import 'codemirror/theme/cobalt.css'

  // 需要引入具体的语法高亮库才会有对应的语法高亮效果
  // codemirror 官方其实支持通过 /addon/mode/loadmode.js 和 /mode/meta.js 来实现动态加载对应语法高亮库
  // 但 vue 貌似没有无法在实例初始化后再动态加载对应 JS ，所以此处才把对应的 JS 提前引入
  import 'codemirror/mode/javascript/javascript.js'
  import 'codemirror/mode/css/css.js'
  import 'codemirror/mode/xml/xml.js'
  import 'codemirror/mode/clike/clike.js'
  import 'codemirror/mode/markdown/markdown.js'
  import 'codemirror/mode/python/python.js'
  import 'codemirror/mode/r/r.js'
  import 'codemirror/mode/shell/shell.js'
  import 'codemirror/mode/sql/sql.js'
  import 'codemirror/mode/swift/swift.js'
  import 'codemirror/mode/vue/vue.js'

  // 尝试获取全局实例
  const CodeMirror = window.CodeMirror || _CodeMirror
  let _this = {}
  export default {
    props:{
      // 是否显示操作列，表格选择组件的时候直接用了这个页面没有重新写，所以要隐藏掉操作列
      hasOperation:{
        type:Boolean,
        default:true
      }
    },
    name: "BasicsElement",
    data() {
      _this = this;
      return {
        project:[],
        isShowDetails: false,
        currComponentName:"",
        data1: [],
        defaultProps: {
          children: 'childList',
          label: 'name'
        },
        defaultKey: [],
        treeData:{},
        isNew:true,
        tablemain: {
          //不显示表格操作列
          hasOperation: this.hasOperation,
          hasExport: this.hasOperation,//导出
          hasEdit: false,
          hasDelete: false,
          //el-table设置
          tableAttrs: {
            height: "86%",
            width: "800px",
          },
          //el-table事件设置
          tableOns: {},
          //表格中的操作列设置
          operationAttrs: {
            width: "290px"
          },
          //格式化表格字段显示，按照类属性定义格式化函数
          formatters: {
            enabledState: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "停用"
              } else if (cellValue == '1') {
                return "启用"
              }
            },
            cacheStatus: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "不缓存"
              } else if (cellValue == '1') {
                return "缓存"
              } 
            },
            componentType: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "PC组件"
              } else if (cellValue == '1') {
                return "移动端组件"
              }
            },
            enabledState: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "停用"
              } else if (cellValue == '1') {
                return "启用"
              }
            },
            loginState: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "登入前"
              } else if (cellValue == '1') {
                return "登入后"
              }
            },
            dragStatus: function (row, column, cellValue, index) {
              if (cellValue == '0') {
                return "否"
              } else if (cellValue == '1') {
                return "是"
              }
            },
            projectCode: function (row, column, cellValue, index) {
              return _this.project.filter(x => x.projectCode == cellValue).length>0? _this.project.filter(x => x.projectCode == cellValue)[0].projectName:cellValue
            }
          },
          single: false, //单选
          //admin微服务网址
          hostUrl: this.zuul,
          //表初始化关键字，一般为表名
          tableName: "SysComponent",
          //查询时的排序字段
          sorter: [],
          //业务数据微服务,查询与高级查询
          bQuery: {
            hostUrl: this.zuul,
            url: "/xyj-admin/r/sysComponent/query",
            method: 'post',
            notCondition: false //没有查询条件则查询全部数据
          },
          bDeleteUrl: {
            hostUrl: this.zuul,
            url: "/xyj-admin/w/sysComponent/delete",
            method: 'post',
            notCondition: true //没有查询条件则查询全部数据
          },
          // customQuery: {
          //   100:{
          //     field100: "treeCode",
          //     gx100: "EQUAL",
          //     value100: "BaseModule",
          //     andor100: "AND"
          //   }
          // }, //表格初始化时查询条件
          bExport: {
            // url: baseUrl+"/sysTableinfo/query", //查询接口，如果不填写默认为表格查询网址bQuery
            tableName: " SysComponent",//如果为空系统默认为，表初始化关键字
            fileName: ""//自定义文件名,如果为空则根据实体类名称定义下载文件名
          },
        },
        currID: "",
        dialogVisible: false,
        ruleForm: {
          id: '',
          componentName: '',
          componentType: '',
          enabledState: '',
          // homeState: '',
          treeCode: '',
          elementName: '',
          componentChineseName:'',
          dragStatus:'1',
          loginState:'',
          cacheStatus:1,
          projectCode:'',
          componentVersion:""
        },
        rules: {
          componentName: [
            {required: true, message: '请输入组件名称', trigger: 'blur'},
          ],
          componentType:[
            {required: true, message: '请选择组件类型', trigger: 'change'},
          ],
          elementName: [
            {required: true, message: '请输入HTML标签名称', trigger: 'blur'},
          ],
          name: [
            {required: true, message: '请输入活动名称', trigger: 'blur'},
          ],
          cacheStatus: [
            {required: true, message: '请选择是否缓存', trigger: 'change'},
          ],
        },


        /*编辑器*/

        // 内部真实的内容
        code: '',
        // 当前的版本号
        componentVersion: '',
        // 默认的语法类型
        mode: 'x-vue',
        // 编辑器实例
        coder: null,
        // 默认配置
        options: {
          // 缩进格式
          tabSize: 2,
          // 主题，对应主题库 JS 需要提前引入
          theme: 'cobalt',
          // 显示行号
          lineNumbers: true,
          line: true
        },
        modes: [{
          value: 'css',
          label: 'CSS'
        }, {
          value: 'javascript',
          label: 'Javascript'
        }, {
          value: 'html',
          label: 'XML/HTML'
        }, {
          value: 'x-java',
          label: 'Java'
        }, {
          value: 'x-objectivec',
          label: 'Objective-C'
        }, {
          value: 'x-python',
          label: 'Python'
        }, {
          value: 'x-rsrc',
          label: 'R'
        }, {
          value: 'x-sh',
          label: 'Shell'
        }, {
          value: 'x-sql',
          label: 'SQL'
        }, {
          value: 'x-swift',
          label: 'Swift'
        }, {
          value: 'x-vue',
          label: 'Vue'
        }, {
          value: 'markdown',
          label: 'Markdown'
        }]
      }
    },
    created(){
      this.geprojectCode()
    },
    mounted() {
      this.getTree();
    },
    methods: {
      componentNameInput(val){
        let codeReg = new RegExp("[a-z0-9]+");
        let len = val.length;
        let str = "";
        for(let i=0; i<len; i++){
          if(codeReg.test(val[i])){
            str+=val[i];
          }
        }
        this.ruleForm.componentName = str;
      },
      elementNameInput(val){
        let codeReg = new RegExp("[a-z0-9]+");
        let len = val.length;
        let str = "";
        for(let i=0; i<len; i++){
          if(codeReg.test(val[i])){
            str+=val[i];
          }
        }
        this.ruleForm.elementName = str;
      },
      geprojectCode(){
        this.axios({
          url:this.zuul+"/xyj-admin/r/sysProject/query",
          method:"post",
          data:{}
        }).then(res => {
          this.project = res.data.rows
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      enabled(row,callback) {
        this.axios({
          url:this.zuul+"/xyj-admin/w/sysComponent/StartOrStop" + '?id=' + row.id,
          method:'get'
        }).then(res => {
          this.$message({type: "success", message: "操作成功！"});
          this.$refs.reftableBasicsElement.getList();
        }).catch(err => {
          this.$message.error(err.message)
        })
        callback();
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveNew();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      saveNew() {
        this.dialogVisible = false;
        this.axios({
          url: this.zuul+"/xyj-admin/w/sysComponent/save",
          method:'post',
          data: this.ruleForm
        }).then(res => {
          if (res.code == 200) {
            this.$message({type: "success", message: "保存成功！"});
            this.$refs.reftableBasicsElement.getList({
              0: {
                field0: "treeCode",
                gx0: "IN",
                value0: this.$tu.recursive([this.treeData],'code','childList'),
                andor0: "AND"
              }
            });
            return false
          }
        }).catch(err => {
          this.$message({type: "error", message: err.message});
        })
      },
      addNew(callback) {
        if (Object.keys(this.treeData).length == 0) {
          this.$message({type:"warning",message:"不能在根节点新增!"});
          callback();
          return false;
        }
        this.isNew = true;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields();
          this.ruleForm.treeCode = this.treeData.code;
          this.ruleForm.id = "";
          this.ruleForm.enabledState = 1;
          // this.ruleForm.homeState = '0';
          this.ruleForm.loginState = '0'
          this.ruleForm.cacheStatus = 1
          this.ruleForm.componentVersion = "";
        });
        callback();
      },
      editRow(row,callback) {
        this.isNew = false;
        this.dialogVisible = true;
        this.$nextTick(() => {
          for (let item in this.ruleForm) {
            if (row[item]!==""||row[item]!==null||row[item]!==undefined){
              this.ruleForm[item] = row[item];
            }else {
              this.ruleForm[item] = "";
            }
          }
        })
        callback()
      },
      deleteRow(row,callback){
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteFunc(row);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        callback();
      },
      deleteFunc(row){
        this.$api.common.xyjPost({
          url: "/xyj-admin/w/sysComponent/delete",
          data: [row.id]
        }).then(res => {
          if (res.code == 200) {
            this.$message({type: "success", message: "删除成功！"});
            this.$refs.reftableBasicsElement.getList({
              0: {
                field0: "treeCode",
                gx0: "IN",
                value0: this.$tu.recursive([this.treeData],'code','childList'),
                andor0: "AND"
              }
            });
            return false
          }
          this.$message({type: "error", message: res.message});
        })
      },
      componentTypeChange(val) {
        if (val == '0') {
          // this.ruleForm.homeState = '0';
        }
      },
      openView(row,callback) {
        this.isShowDetails = true;
        this.currID = row.id;
        this.currComponentName = row.componentName;
        this.$api.common.xyjGet({
          url: this.zuul+"/xyj-admin/r/sysComponent/findById" + '?id=' + row.id,
        }).then(res => {
          this.code = res.data.componentCode?res.data.componentCode:'';
          this.componentVersion = res.data.componentVersion?res.data.componentVersion:'';
          // 初始化
          this._initialize()
        });
        callback();

      },
      save() {
        this.$api.common.xyjPost({
          url: this.zuul+"/xyj-admin/w/sysComponent/saveCode",
          data: {
            id: this.currID,
            componentCode: this.code,
            componentVersion: this.componentVersion.toString(),
          }
        }).then(res => {
          if (res.code == 200) {
            this.componentVersion = res.data.componentVersion;
            this.$message({type: "success", message: "保存成功！"});
            return false
          }
          this.$message({type: "error", message: res.response.data.message});
        }).catch(err => {
          this.$message({type: "error", message: err.message});
        })
      },
      goBack() {
        this.isShowDetails = false;
      },
      // 初始化
      _initialize() {
        // 初始化编辑器实例，传入需要被实例化的文本域对象和默认配置
        this.coder = CodeMirror.fromTextArea(this.$refs.textarea, this.options)
        // 编辑器赋值
        this.coder.setValue(this.value || this.code)

        // 支持双向绑定
        this.coder.on('change', (coder) => {
          this.code = coder.getValue()

          if (this.$emit) {
            this.$emit('input', this.code)
          }
        })

        // 尝试从父容器获取语法类型
        if (this.language) {
          // 获取具体的语法类型对象
          let modeObj = this._getLanguage(this.language)

          // 判断父容器传入的语法是否被支持
          if (modeObj) {
            this.mode = modeObj.label
          }
        }
      },
      // 获取当前语法类型
      _getLanguage(language) {
        // 在支持的语法类型列表中寻找传入的语法类型
        return this.modes.find((mode) => {
          // 所有的值都忽略大小写，方便比较
          let currentLanguage = language.toLowerCase()
          let currentLabel = mode.label.toLowerCase()
          let currentValue = mode.value.toLowerCase()

          // 由于真实值可能不规范，例如 java 的真实值是 x-java ，所以讲 value 和 label 同时和传入语法进行比较
          return currentLabel === currentLanguage || currentValue === currentLanguage
        })
      },
      // 更改模式
      changeMode(val) {
        // 修改编辑器的语法配置
        this.coder.setOption('mode', `text/${val}`)

        // 获取修改后的语法
        let label = this._getLanguage(val).label.toLowerCase()

        // 允许父容器通过以下函数监听当前的语法值
        this.$emit('language-change', label)
      },
      change(data, isChecked) {
        // this.$refs.reftableBasicsElement.notCondition = true
        this.$refs.reftableBasicsElement.sizeChangeQuery = {
          100:{
            field100: "treeCode",
            gx100: "IN",
            value100: this.$tu.recursive([data],'code','childList'),
            andor100: "AND"
          }
        }
        // this.$refs.reftableBasicsElement.getList({100: {
        //     field0: "treeCode",
        //     gx0: "IN",
        //     value0: this.$tu.recursive([data],'code','childList'),
        //     andor0: "AND"
        //   }})
        // 节点选中状态发生变化
        this.$refs.tree.setCheckedNodes([data])

      },
      changes(data) {
        this.$refs.reftableBasicsElement.sizeChangeQuery = {
          100:{
            field100: "treeCode",
            gx100: "IN",
            value100: this.$tu.recursive([data],'code','childList'),
            andor100: "AND"
          }
        }
        this.$refs.reftableBasicsElement.getList()
        this.$refs.tree.setCheckedNodes([data]);
        if (this.data1[0].id !== data.id) {
          this.treeData = data;  
        }else {
          this.treeData = {};
          // this.$refs.reftableBasicsElement.getList();
        }

      },
      getTree() {
        axios({
          // 用axios发送post请求
          hostUrl: this.zuul,
          method: "get",
          url: "/xyj-admin/r/sysTree/fiandByCode?code=BaseModule",
        })
          .then(res => {
            if (res.code == 200) {
              this.data1 = JSON.parse(JSON.stringify([res.data]));
              this.treeData = this.data1[0]
              function formatter(data) {
                data.forEach(element => {
                  if (element.childList && element.childList.length > 0) {
                    let flag = formatter(element.childList);
                    if (flag) return false;
                  } else {
                    element.name = element.name + ' | ' + element.code
                    element.childList
                    return true;
                  }
                  element.name = element.name + ' | ' + element.code
                })
              }

              formatter(this.data1)
            }
            this.defaultKey = [this.data1[0].id];
            this.$refs.reftableBasicsElement.notCondition = true
            this.$refs.reftableBasicsElement.sizeChangeQuery = {
              100:{
                field100: "treeCode",
                gx100: "IN",
                value100: this.$tu.recursive(this.data1,'code','childList'),
                andor100: "AND"
              }
            }
            this.$refs.reftableBasicsElement.getList({100: {
                field100: "treeCode",
                gx100: "IN",
                value100: this.$tu.recursive(this.data1,'code','childList'),
                andor100: "AND"
              }})
          })
          .catch(err => {
            this.$message.error(err.message);
          })
      }
    }
  }
</script>

<style lang="scss">
  .basics-element {
    display: flex;
    flex-direction: column;
    height: 100%;

    .side-bar {
      width: 240px;
      height: 100%;
      overflow: auto;
      border-right: 1px solid #eeeeee;
    }

    .basics-right {
      flex: 1;
      overflow: auto;
      padding-left: 15px;
    }

    .in-coder-panel {
      flex-grow: 1;
      display: flex;
      position: relative;
    }


    .CodeMirror {
      flex-grow: 1;
      z-index: 1;
      width: 100%;
      height: 100%;
    }

    .CodeMirror-code {
      line-height: 19px;
    }


    .code-mode-select {
      position: absolute;
      z-index: 2;
      right: 10px;
      top: 10px;
      max-width: 130px;
    }

    .details-page {
      width: 100%;
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
    }

    .details-header {
      align-items: center;
      background-color: #f5f5f5;
      padding: 5px 10px;
    }
    .el-radio-group{
      width: 100%;
      display: flex;

    }

  }


</style>



// WEBPACK FOOTER //
// src/views/ElementSet/BasicsElement.vue